import { Box, Typography } from '@mui/material'

export default function DimensionSplitSection({ title, paragraphs = [] }) {
  if (!title || paragraphs.length === 0) return null

  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: { xs: 3, md: 4, lg: 6 },
        width: '100%',
      }}
    >
      <Typography
        component="h2"
        sx={{
          fontSize: { xs: 22, md: 22 },
          lineHeight: 1.2,
          fontWeight: 400,
          color: '#111',
          flexShrink: 0,
          position: { md: 'sticky' },
          top: { md: 0 },
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 2, md: '32px' },
          width: { xs: '100%', lg: 1000 },
          maxWidth: '100%',
        }}
      >
        {paragraphs.map((text) => (
          <Typography
            key={text}
            sx={{
              fontSize: { xs: 18, sm: 22, md: 28, lg: 30 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
            }}
          >
            {text}
          </Typography>
        ))}
      </Box>
    </Box>
  )
}
